var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIpinLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 39C32.2843 39 39 32.2843 39 24C39 15.7157 32.2843 9 24 9C15.7157 9 9 15.7157 9 24C9 32.2843 15.7157 39 24 39Z",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6322 28.0871H13.71V19.9004H15.6322V28.0871Z",
    fill: "#121619"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8761 19.9004H20.2231C20.83 19.9004 21.3576 20.0191 21.8062 20.2566C22.2547 20.4903 22.5977 20.8201 22.8352 21.246C23.0764 21.6719 23.197 22.1619 23.197 22.716C23.197 23.2776 23.0745 23.7695 22.8295 24.1916C22.5883 24.6138 22.2378 24.9417 21.7779 25.1754C21.3218 25.4053 20.7847 25.5203 20.1666 25.5203H18.7984V28.0871H16.8761V19.9004ZM19.816 23.9937C20.2608 23.9975 20.6038 23.8844 20.845 23.6545C21.0863 23.4246 21.2069 23.1117 21.2069 22.716C21.2069 22.3277 21.0863 22.0224 20.845 21.8001C20.6076 21.5739 20.2646 21.4608 19.816 21.4608H18.7984V23.9937H19.816Z",
    fill: "#121619"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0917 28.0871H24.1695V19.9004H26.0917V28.0871Z",
    fill: "#121619"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2784 28.0871H32.6388L29.3144 23.2814H29.2579V28.0871H27.3356V19.9004H28.9978L32.2883 24.7061H32.3561V19.9004H34.2784V28.0871Z",
    fill: "#121619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIpinLight);
export default __webpack_public_path__ + "static/media/icon_ipin_light.f177976e.svg";
export { ForwardRef as ReactComponent };